import { usePitstopConfiguration } from "core/context/AppConfigurationContext";
import { getApiUrl } from "core/utils/getApiUrl";

export function getImageSRC(blobName: string, apiUrl: string) {
  return getApiUrl(
    `/api/news-events/articles-v2/download?fileId=${blobName}`,
    apiUrl
  );
}

export function useGetImageSRC() {
  const { API_URL } = usePitstopConfiguration();
  return (blobName: string) => getImageSRC(blobName, API_URL!);
}
